module.exports = __webpack_public_path__ + "static/media/social.917ef198.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mockData/images/social.jpg
// module id = 378
// module chunks = 0